//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    background-color: #283044cc;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 800;
    opacity: 0;
    visibility: hidden;
    transition: 0.4s;
    &.opened {
        opacity: 1;
        visibility: visible;
    }
`;